import { ForgotPasswordInput } from '../../lib/types/models/auth/forgot-password'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function forgotPassword(data: ForgotPasswordInput) {
  return restApiClient
    .url(constructApiUrl(API.auth.forgotPassword.url, null))
    .post<never, ForgotPasswordInput>(data)
}
